export default __webpack_public_path__ + "static/media/HSL_OpenMaaS-rajapinnan_tietosuojaseloste_20190730.9efa2949.pdf";